import Api from '@/data/Api.ts';
import StringUtils from '@/infrastructure/support/utils/StringUtils.ts';
import type Company from '@/domain/model/business/Company';

const API_URL_SEARCH_SUGGESTIONS = '/companies/{0}/search-suggestions';

export default class SearchSuggestionsApi extends Api {
  getSearchSuggestions(company: Company, query: string): Promise<any> {
    return this.standardGet(
      StringUtils.stringFormat(API_URL_SEARCH_SUGGESTIONS, [company.getId()]),
      { query: query },
      [],
    );
  }
}
